import React, {useRef, useCallback} from 'react'
import {Link, Route, Routes, useLocation, useNavigate, useSearchParams} from 'react-router-dom'
import Tabbar from '../../components/Tabbar'
import Profile from '../../components/Profile'
import Search from '../../components/Search'
import '../../styles/css/Karyawan.css'
import searchIcon from '../../assets/icons/search-icon.svg'
import {useDispatch, useSelector} from 'react-redux'
import Sidebar from '../../components/sidebar/Sidebar'
import {useEffect} from 'react'
import {getKategori, setCurrentKategori, setIsInitial, setKategoriId} from '../../features/ketegoriSlice'
import {useState} from 'react'
import {getSiswa, importSiswa, resetTable, updateFieldValue, updateStateSiswa,listGetSiswa} from '../../features/siswaSlice'
import InfoBox from '../../components/InfoBox'
import LoadingTable from '../../components/LoadingTable'
import LoadingTabbar from '../../components/LoadingTabbar'
import Skeleton from 'react-loading-skeleton'
import Table from "../../components/student/Table";
import arrowDownIcon from '../../assets/icons/arrow-right.svg'
import Button from "../../components/Button";
import {getJadwalGuru, importJadwal} from "../../features/jadwalGuruSlice";
import Download from "../../components/student/Download";
import Filter from "../../components/student/Filter";
import PilihTanggal from "../../components/jurnal/PilihTanggal";
import {getJurnal, updateStateJurnal} from "../../features/jurnalSlice";
import calenderIcon from "../../assets/icons/arrow-right.svg";
import {updateStateWaliKelas} from "../../features/waliKelasSlice";
import {updateStateJurnalSiswa} from "../../features/jurnalSiswaSlice";

const GREY = '#9B9B9B'
const BORDER = '#ECEEF2'
function Siswa() {
    const {
        listSiswa,
        isLoading,
        statusResApi,
        messageResApi,
        isDisplayMessage,
        startText, endText,
        startTime, endTime,
        search,
        listKelas,
        kelas
    } = useSelector(state => state.siswa)

    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const inputFileRef = useRef(null)
    const [showModal, setShowModal] = useState(false)
    const [file, setFile] = useState(null)
    const [searchParams, setSearchParams] = useSearchParams()
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(null)
    let kategoriAll = [
        {id: 'all', kategori: 'Semua Siswa'},
    ]

    useEffect(() => {
        dispatch(resetTable())
    }, [dispatch]);




    useEffect(() => {
        if (searchParams.get('paginate')) {
            dispatch(updateStateSiswa({name: 'currentPage', value: parseInt(searchParams.get('paginate'))}));
        }
    }, [location.pathname, navigate, searchParams]);

    useEffect(() => {
        // Initialize from URL params if available, otherwise load default data
        const urlSearch = searchParams.get('search');
        const urlStartTime = searchParams.get('start_time');
        const urlEndTime = searchParams.get('end_time');
        const urlKelas = searchParams.get('kelas');
        
        if (urlSearch || urlStartTime || urlEndTime || urlKelas) {
            // Load from URL params
            if (urlSearch) {
                dispatch(updateStateSiswa({name: 'search', value: urlSearch}));
            }
            if (urlKelas) {
                dispatch(updateStateSiswa({name: 'kelas', value: urlKelas}));
            }

            console.log(urlStartTime)
            dispatch(getSiswa({
                search: urlSearch || '',
                start_time: urlStartTime || startTime,
                end_time: urlEndTime || endTime,
                kelas: urlKelas || ''
            }))
        } else {
            // Load default data
            dispatch(getSiswa({}))
        }
        
        // Always load class list
        dispatch(listGetSiswa({}))
    }, []);


    useEffect(() => {
        dispatch(updateStateSiswa({name: 'currentPage', value: 1}))
    }, [location.pathname.split('/').pop()]);


    function handleSearch() {
        dispatch(getSiswa({ 
            start_time: startTime, 
            end_time: endTime, 
            kelas: kelas || '',
            search: search 
        }))
        dispatch(updateStateSiswa({name: 'currentPage', value: 1}))
        setSearchParams({
            'search': search || '',
            'start_time': startTime || '',
            'end_time': endTime || '',
            'kelas': kelas || ''
        })
    }

    const handleFilterChange = useCallback((selectedKelas) => {
        dispatch(updateStateSiswa({name: 'currentPage', value: 1}))
        dispatch(getSiswa({ 
            start_time: startTime, 
            end_time: endTime, 
            kelas: selectedKelas || '',
            search: search 
        }))
        setSearchParams({
            'search': search || '',
            'start_time': startTime || '',
            'end_time': endTime || '',
            'kelas': selectedKelas || ''
        })
    }, [startTime, endTime, search, dispatch, setSearchParams])

    function handleKeyDown(e) {
        if (e.key === 'Enter') {
            handleSearch();
        }
    }

    function handleChange(e) {
        e.preventDefault();
        setShowModal(true)
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    }

    function handleImport() {
        dispatch(importSiswa(file))
            .then((res) => {
                if (res.meta.requestStatus === "fulfilled") {
                    setShowModal(false)
                    dispatch(getSiswa({}))
                    inputFileRef.current.value = '';
                }
            })
    }

    return (
        <div className='wrapper-karyawan'>
            <Sidebar/>
            <div className='karyawan'>



                <div className='search-and-profile'>

                    <div className={'wrap-search'}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: '#fff', border: `1px solid ${BORDER}`, borderRadius: 10, padding: '0 16px', height: 48, width: 300, marginRight: 16 }}>
                            <span style={{ color: GREY, fontSize: 14 }}>🔍</span>
                            <input
                                type="text"
                                placeholder="Cari guru"
                                value={search}
                                onKeyDown={handleKeyDown}
                                onChange={(e) => dispatch(updateStateSiswa({ name: 'search', value: e.target.value }))}
                                style={{ border: 'none', outline: 'none', fontSize: 14, color: '#A6A6A6', flex: 1 }}
                            />
                        </div>


                            <div className='wrap-search' style={{marginRight:15}}>
                                <div className='wrapper-pilih-tanggal' style={{ marginRight: 0 }}>
                                    <style>{`
.btn-pilih-tanggal {
border: 1px solid ${BORDER};
border-radius: 10px;
}

.pilih-tanggal {
border: none !important;
}


  `}</style>
                                    <PilihTanggal
                                        text={startText}
                                        setText={updateStateSiswa}
                                        stateText='startText'

                                        setDate={setStartDate}
                                        date={startDate}

                                        setTime={updateStateSiswa}
                                        stateTime='startTime'
                                    />
                                    <img src={calenderIcon} alt="" />
                                    <PilihTanggal
                                        text={endText}
                                        setText={updateStateSiswa}
                                        stateText='endText'

                                        setDate={setEndDate}
                                        date={endDate}

                                        setTime={updateStateSiswa}
                                        stateTime='endTime'
                                    />
                                </div>
                            </div>


                        <button
                            className='btn-search'
                            style={{ background: '#fff', border: `1px solid ${BORDER}`, borderRadius: 10, padding: '0 16px', height: 48, width: 48 }}
                            onClick={handleSearch}
                        >
                            <img src={searchIcon} alt="" />
                        </button>
                    </div>
                    <Profile />
                </div>



                {showModal &&
                    <div className='bg-modal'>
                        <div className='alert-modal'>
                            <h1>Import Siswa</h1>
                            <p>Apakah anda yakin ?</p>
                            <div>
                                <button onClick={() => setShowModal(false)}>Tidak</button>
                                <button onClick={handleImport}>Iya</button>
                            </div>
                        </div>
                    </div>
                }



                <div className='title-btn'>
                    <h1>Siswa</h1>
                    <div style={{display: 'flex', flexDirection: 'row', gap: '10px'}}>

                        <div className='right-header'>
                            <Button
                                style={{
                                    width: "150px",
                                    height: "45px"
                                }}
                                text={'Import Siswa'}
                                onClick={() => inputFileRef.current.click()}
                            />
                            <input
                                style={{display: 'none'}}
                                ref={inputFileRef}
                                type="file"
                                onChange={handleChange}
                                accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'

                            />
                        </div>
                        <Link to='/siswa/add'>+ Add New</Link>
                    </div>
                </div>

                <div className='tabbar-filter'>
                    <Tabbar
                        options={[...kategoriAll]}
                        setKategoriId={setKategoriId}
                        setCurrentKategori={setCurrentKategori}
                        searchParams={''}
                        setKeterangan={updateStateSiswa}
                        path='/siswa'
                        sttic={true}

                    />

                    <div className='filter-angka'>
                        <Filter 
                            option={listKelas}
                            setState={updateStateSiswa}
                            onFilterChange={handleFilterChange}
                        />
                            <Download />

                    </div>
                </div>


                {(isLoading) ?
                    <LoadingTable size={'large'}/>
                    : <Table/>
                }
            </div>
        </div>
    )
}

export default Siswa